export const css = {
    root: '_3bFvqFRk',
    ' _key': 'afcpe-theme/dojo/accordion'
};
export default css;
